import React, { useEffect, useState } from "react";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Link } from "react-router-dom";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useGlobalContext } from "../../../Context/GlobalContext";
import ClipLoader from "react-spinners/ClipLoader";
import { div } from "framer-motion/client";
import { stepButtonClasses } from "@mui/material";
import Cookies from "js-cookie";

const SalaryOverview = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { baseUrl, selectedStaff } = useGlobalContext();
  const [staff, setStaff] = React.useState([]);
  const formatMonthYear = (value) => {
    const [year, month] = value.split("-");
    const date = new Date(year, month - 1); // JS months are 0-indexed
    return date.toLocaleString("default", { month: "long", year: "numeric" });
  };
  // const [selectedMonth, setSelectedMonth] = React.useState();
  const getData = async (e) => {
    try {
      setIsLoading(true);
      const response = await fetch(
        baseUrl + "salary/" + selectedStaff?.staffDetails?.id,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`
          },
        }
      );

      if (response.status === 200) {
        const result = await response.json();
        console.log(result);
        setStaff(result?.data);
      } else {
        console.error(
          "Failed to retrieve data:",
          response.status,
          response.statusText
        );
      }
    } catch (error) {
      console.error("An error occurred while fetching data:", error);
    }
    finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const getMonthStartEndDates = (effectiveDate) => {
    if (!effectiveDate) return "Invalid Date";

    const date = new Date(effectiveDate);
    const year = date.getFullYear();
    const month = date.getMonth(); // 0-based index (0 = January, 11 = December)

    const startDate = 1; // First day of the month
    const endDate = new Date(year, month + 1, 0).getDate(); // Last day of the month

    const monthName = date.toLocaleString("en-US", { month: "long" });

    return `${startDate} ${monthName} ${year} - ${endDate} ${monthName} ${year}`;
  };


  return (
    <>
      <div className='relative flex flex-col xl:pt-[30px] pb-[30px] w-full'>
        <div className="top-0 flex justify-between items-center bg-white shadow-cs mb-4 pt-[14px] pr-[14px] pb-[14px] pl-[14px] rounded-md w-[100%]">
          <h3 className="font-medium">Salary Overview</h3>
          <button className="second-btn">Update Details</button>
        </div>
        <div className="flex justify-center">
          {staff.length === 0 && !isLoading && (
            <p className="mt-4 font-medium text-[#ff0000] text-md">No salary details available at this time.</p>
          )}
          {isLoading && <ClipLoader color="#24007a" size={50} />}
        </div>
        {staff?.map((salary) => (
          <div className="flex md:flex-row lg:flex-row xl:flex-row flex-col justify-between items-start md:items-center lg:items-center xl:items-center gap-[10px] bg-white shadow mb-4 p-4 rounded-md w-full text-[#000] text-[14px] text-start">
            <div className="flex gap-[10px]">
              <CalendarMonthIcon className="calender-icon" />
              <div>
                <h6 className="font-medium">
                  {formatMonthYear(salary?.effective_date)}
                </h6>
                <p className="text-[#9c8f8f]">
                  Duration:{getMonthStartEndDates(salary?.effective_date)}
                </p>
              </div>
            </div>
            <div>
              <h3 className="">Due Amount</h3>
              <h2 className="font-medium">Rs. {salary?.ctc_amount}</h2>
            </div>
            <div className="w-full md:w-auto lg:w-auto xl:w-auto text-end">
              <Link
                to="/staff-salary-summary"
                className="bg-[#27004a] p-[7px] rounded-md text-white"
              >
                <KeyboardArrowRightIcon />
              </Link>
            </div>
          </div>
        ))}

        <div className="mt-[40px] text-center" onClick={getData}>
          <button className="second-btn">Load More</button>
        </div>

      </div>
    </>
  );
};

export default SalaryOverview;
